type AppNotification = {
  key: string;
  flags: string[];
  args: { [key: string]: string };
};

const appNotification: AppNotification = {
  key: "",
  flags: [],
  args: {},
};

export type { AppNotification };

export { appNotification };
